import cs from "classnames";
import React from "react";
import { FaRegQuestionCircle } from "react-icons/fa";

import { Tooltip } from "src/common/components/Tooltip";
import { mapPathToString } from "src/common/utils/common";

import "./Field.css";

interface FieldProps {
	required?: boolean;
	label?: React.ReactNode;
	help?: React.ReactNode;
	error?: React.ReactNode;
	path?: (string | number)[];
}

export const Field: React.FunctionComponent<
	React.PropsWithChildren<FieldProps>
> = ({ required, label, help, error, path, children }) => {
	const [touched, setTouched] = React.useState(false);

	const onBlur = React.useCallback(({ target }: React.FocusEvent) => {
		if (
			!!(target as any).value &&
			!target.classList.contains("field__ignore-blur-event")
		) {
			setTouched(true);
		}
	}, []);

	return (
		<div
			className={cs("field", {
				"field--required": required,
				"field--touched": touched,
				"field--invalid": error
			})}
			data-fyrms={mapPathToString(path)}
		>
			<div className="field__label-wrapper">
				{label && (
					<label className="field__label">
						{label}
						{required && " *"}
					</label>
				)}
				{help && (
					<Tooltip
						canWrap={true}
						maxWidth={300}
						topOffset={-1}
						leftOffset={-19}
						title={help}
						content={<FaRegQuestionCircle />}
					/>
				)}
			</div>
			<div className="field__input-wrapper" onBlur={onBlur}>
				{children}
			</div>
			{error && <div className="field__error">{error}</div>}
		</div>
	);
};
